import React from 'react';
import { UidStateInterface } from './RtcContext';

const UidContext = React.createContext<UidStateInterface['uids']>([]);
export const UidProvider = UidContext.Provider;
export const UidConsumer = UidContext.Consumer;
export default UidContext;
